import { render, staticRenderFns } from "./OwnerMenu.vue?vue&type=template&id=38342ce2&scoped=true&"
import script from "./OwnerMenu.vue?vue&type=script&lang=ts&"
export * from "./OwnerMenu.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerMenu.vue?vue&type=style&index=0&id=38342ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38342ce2",
  null
  
)

export default component.exports